import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PAYMENTS_WIRE_BASE_PATH } from '../../../../../../../../../features/payments/wire/payments-wire-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/payment/wire/_wire')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'wire-payment-list',
        label: 'Payments',
        to: PAYMENTS_WIRE_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
